<template>
  <NavNuxtLink
    class="flex shrink-0 cursor-pointer border-t border-white/10 p-3 transition-colors"
    to="/settings"
  >
    <div
      class="group block w-full rounded-lg px-3 py-2.5 transition-colors hover:bg-fp-green-7/50"
    >
      <div class="flex items-center gap-3">
        <div class="shrink-0">
          <UserAvatar
            :avatar-url="avatarUrl"
            :class="[small ? 'h-8 w-8' : 'h-10 w-10']"
          />
        </div>
        <p
          :class="[small ? 'text-sm' : 'text-base']"
          class="min-w-0 flex-1 truncate font-medium text-fp-green-1"
        >
          {{ displayName }}
        </p>
        <ChevronRightIcon
          class="h-5 w-5 shrink-0 text-fp-green-1"
          aria-hidden="true"
        />
      </div>
    </div>
  </NavNuxtLink>
</template>

<script lang="ts" setup>
import { ChevronRightIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'
import UserAvatar from '~/components/navigation/UserAvatar.vue'
import NavNuxtLink from '~~/components/navigation/NavNuxtLink'
import { useUserSessionStore } from '~~/store/user-session'

defineProps({
  small: {
    type: Boolean,
    default: false,
  },
})

const userSessionStore = useUserSessionStore()

const { name: displayName, avatarUrl } = storeToRefs(userSessionStore)
const { getData } = userSessionStore

// This is called using useAsyncData so that this data is populated on
// the server (SSR), i.e. blocks navigation until this is resolved.
await useAsyncData(
  'getUserSessionData',
  // Make sure to return a value. This will allow Nuxt to skip running the action on the client side and reuse the value from the server.
  async () => await getData().then(() => true)
)
</script>
